import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/app/page.tsx");
